import { Alert, Container, Icon, Paper, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export function PaymentConfirmation() {
    const navigate = useNavigate();
    useEffect(() => {

        setTimeout(() => {
            navigate("../");
            window.location.reload();
        }, 2000)

    }, []);

    return (
        <Container maxWidth="sm">
            <Paper sx={{ padding: 3 }}>

                <Alert icon={<Icon>check</Icon>} severity="success">
                    Thank you, your payment has been successfully processed!
                </Alert>

                <Typography variant="h6" textAlign="center" color="primary" marginBottom={2}>
                </Typography>

                <Typography style={{ width: "100%", "textAlign": "center" }} textAlign="center" color="primary" marginBottom={2}>
                    You are being redirected
                </Typography>
            </Paper>
        </Container>
    );
};

